import PolicyShell from "./legal/PolicyShell";
import { TERMS_OF_USE } from "./legal/data/termsOfUse";

export default function TermsOfUsePage() {
  return <PolicyShell data={TERMS_OF_USE} />;
}
